import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useRecentCompetitions(userId?: string, now?: Date) : Competition[] | undefined {

    const groupCompetitions = useQuery<Competition>({ userId: userId, queryType: 'recentCompetitions', date: now});
    return groupCompetitions;
}

